import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDownRegular } from "@fluentui/react-icons";

export interface DropdownButtonProps {
  width?: string;
  items: {
    key: string;
    item: React.ReactNode;
    disabled?: boolean;
    hide?: boolean;
    onClick?: () => Promise<void> | void;
  }[];
}

function DropdownButton({ width, items }: DropdownButtonProps) {
  const showItems = items.filter((item) => !item.hide);
  if (showItems.length === 0) return null;
  if (showItems.length === 1) {
    return (
      <Button
        style={{ width }}
        onClick={showItems[0].onClick}
        disabled={showItems[0].disabled}
        variant="outline"
      >
        {showItems[0].item}
      </Button>
    );
  }
  const [first, ...rest] = showItems;
  return (
    <DropdownMenu>
      <div
        style={{ width }}
        className="inline-flex divide-x-2 divide-primary border-2 border-primary rounded-md"
      >
        <Button
          className="rounded-r-none flex-grow"
          onClick={first.onClick}
          disabled={first.disabled}
          variant="ghost"
        >
          {first.item}
        </Button>
        <DropdownMenuTrigger asChild>
          <Button className="rounded-l-none" variant="ghost" size="icon">
            <ChevronDownRegular />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {rest.map(({ onClick, item, key, disabled }) => (
            <DropdownMenuItem
              disabled={disabled}
              className={` ${disabled ? "text-gray-400" : " cursor-pointer"}`}
              key={key}
              onClick={onClick}
            >
              {item}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </div>
    </DropdownMenu>
  );
}
export default DropdownButton;
